var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Menu'),_c('el-container',{staticClass:"container-home"},[_c('el-aside',{staticClass:"aside-home"},[_c('Aside')],1),_c('el-main',{staticClass:"content-home"},[_c('Content')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }